export const BoxTypes = {
  Trigger: "Trigger",
  EventSource: "EventSource",
  // Públicos
  AudienceGroup: "AudienceGroup",
  FullAudience: "FullAudience",
  SavedAudience: "SavedAudience",
  ImportedAudience: "ImportedAudience",
  BroadcastAudience: "BroadcastAudience",
  // Filtros
  FilterGroup: "FilterGroup",
  AverageTicketFilter: "AverageTicketFilter",
  OrderCountFilter: "OrderCountFilter",
  TotalSpendFilter: "TotalSpendFilter",
  LastConversionFilter: "LastConversionFilter",
  BirthdayFilter: "BirthdayFilter",
  AgeFilter: "AgeFilter",
  RegionFilter: "RegionFilter",
  RegisterTimeFilter: "RegisterTimeFilter",
  ClimateProfileFilter: "ClimateProfileFilter",
  ConsumedProductsFilter: "ConsumedProductsFilter",
  ConsumptionMomentsFilter: "ConsumptionMomentsFilter",
  OriginFilter: "OriginFilter",
  BrandsAndUnitsFilter: "BrandsAndUnitsFilter",
  DaysWithoutConversionFilter: "DaysWithoutConversionFilter",
  OrderFilter: "OrderFilter",
  // Condicionais
  ConditionalGroup: "ConditionalGroup",
  DayOfWeekConditional: "DayOfWeekConditional",
  DayOfMonthConditional: "DayOfMonthConditional",
  SpecificDayConditional: "SpecificDayConditional",
  SpecificClimateConditional: "SpecificClimateConditional",
  AverageTicketConditional: "AverageTicketConditional",
  OrderCountConditional: "OrderCountConditional",
  TotalSpendConditional: "TotalSpendConditional",
  AgeConditional: "AgeConditional",
  LastConversionConditional: "LastConversionConditional",
  BirthdayConditional: "BirthdayConditional",
  RegionConditional: "RegionConditional",
  RegisterTimeConditional: "RegisterTimeConditional",
  ClimateProfileConditional: "ClimateProfileConditional",
  ConsumedProductsConditional: "ConsumedProductsConditional",
  ConsumptionMomentsConditional: "ConsumptionMomentsConditional",
  OriginConditional: "OriginConditional",
  BrandsAndUnitsConditional: "BrandsAndUnitsConditional",
  DaysWithoutConversionConditional: "DaysWithoutConversionConditional",
  OrderConditional: "OrderConditional",
  // Ações
  CreativeGroupAction: "CreativeGroupAction",
  SmsCreativeAction: "SmsCreativeAction",
  PushCreativeAction: "PushCreativeAction",
  EmailCreativeAction: "EmailCreativeAction",
  WhatsAppCreativeAction: "WhatsAppCreativeAction",
  // Saídas
  ExportAudienceOutput: "ExportAudienceOutput",

  OrderFrequencyConditional: "OrderFrequencyConditional",
  OrderFrequencyFilter: "OrderFrequencyFilter",
  RFVProfileConditional: "RFVProfileConditional",
  RFVProfileFilter: "RFVProfileFilter",

  CustomerPhoneFilter: "CustomerPhoneFilter",
};
